import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/** New pages begin at the top. Filters don't jump; deliberate anchors still work. */
export const RouteScrollReset = () => {
    const { pathname, hash } = useLocation();
    useLayoutEffect(() => {
        const previous = window.history.scrollRestoration;
        window.history.scrollRestoration = "manual";
        return () => { window.history.scrollRestoration = previous; };
    }, []);
    useLayoutEffect(() => {
        if (hash.includes("session_id=")) return;
        const root = document.documentElement;
        const previousBehavior = root.style.scrollBehavior;
        const previousAnchor = root.style.overflowAnchor;
        root.style.scrollBehavior = "auto";
        root.style.overflowAnchor = "none";
        const restoreStyles = () => {
            root.style.scrollBehavior = previousBehavior;
            root.style.overflowAnchor = previousAnchor;
        };
        const reset = () => {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            document.querySelectorAll("main, [data-route-scroll-container]").forEach(node => {
                const behavior = node.style.scrollBehavior;
                node.style.scrollBehavior = "auto";
                node.scrollTo({ top: 0, left: 0, behavior: "auto" });
                node.style.scrollBehavior = behavior;
            });
        };
        reset();
        if (!hash) {
            // Route effects and browser scroll anchoring can move the viewport
            // after the initial layout pass. Finish before the next stable paint.
            let secondFrame;
            const firstFrame = requestAnimationFrame(() => {
                reset();
                secondFrame = requestAnimationFrame(() => { reset(); restoreStyles(); });
            });
            return () => { cancelAnimationFrame(firstFrame); cancelAnimationFrame(secondFrame); restoreStyles(); };
        }
        let id;
        try { id = decodeURIComponent(hash.slice(1)); } catch { restoreStyles(); return; }
        const scrollToAnchor = () => {
            const target = document.getElementById(id);
            if (!target) return false;
            target.scrollIntoView({ block: "start", behavior: "auto" });
            restoreStyles();
            return true;
        };
        if (scrollToAnchor()) return restoreStyles;
        // Handles sections rendered after an async page load, without polling.
        const observer = new MutationObserver(() => { if (scrollToAnchor()) observer.disconnect(); });
        observer.observe(document.body, { childList: true, subtree: true });
        const timeout = setTimeout(() => { observer.disconnect(); restoreStyles(); }, 5000);
        return () => { observer.disconnect(); clearTimeout(timeout); restoreStyles(); };
    }, [pathname, hash]);
    return null;
};